import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const initialState = {
  currentUser: {
    accounts: {},
    adAccounts: {},
    avatar: '',
    email: '',
    firebaseAccount: {},
    name: '',
    profile: {},
    token: null
  }
}

export default {
  state: { ...initialState },
  actions,
  getters,
  mutations
}
